<template>
	<div class="success-message">
    <span class="success-text">
      {{ text }}
    </span>

		<span class="success-close"
			  @click="closeMessage">
    </span>
	</div>
</template>

<script>
    export default {
        name: 'message',

        props: ['text'],

        methods: {
            closeMessage () {
                this.$emit('closeMessage')
            }
        }
    }
</script>

<style lang="scss">
	@import '../scss/_variables.scss';
	@import '../scss/_functions.scss';

	.success-message {
		border: {
			color: green;
			radius: $border-radius;
			style: solid;
			width: 1px;
		}
		box-shadow: $box-shadow;
		color: darkgreen;
		display: flex;
		font: {
			family: $sans-serif;
			size: .9rem;
			weight: 500;
		}
		justify-content: space-between;
		margin: {
			bottom: 1rem;
			left: 0;
			right: 0;
			top: 1rem;
		}
		padding: {
			bottom: .75rem;
			left: .75rem;
			right: .75rem;
			top: .75rem;
		}

		.success-text {
			flex: 1;
		}

		.success-close {

			cursor: pointer;
			width: 22px;
		}
	}
</style>



// WEBPACK FOOTER //
// SuccessMessage.vue?16df668a